import * as types from './mutation-types'
import {LOAD_USER_DOOR_SONOTE, LOAD_USER_RIGHT} from "./mutation-types";

export default {
  [types.LOAD_PERIMETERS](state, data) {
    state.perimeters = data.data
  },
  [types.LOAD_MAIN_PERIMETERS](state, data) {
    state.main_perimeters = data.data
  },

  [types.LOAD_USER_RIGHT](state, data) {
    state.user_right = data
  },
    [types.LOAD_USER_DOOR_SONOTE](state, data) {
        state.user_assign = data
    },
}
